import React from 'react'
import { Popup, Button, SafeArea } from 'antd-mobile'
import { appWidth } from '@/const/config'
import { isMobile } from '@/utils/common'

export default function EditDrawer(props) {
  const { position, open, onClose, title, onClickSave, children, isLoading, saveContent } = props
  let height = '100%'
  if (props.height) {
    height = props.height
  }

  React.useEffect(() => {
    window.onpopstate = function () {
      onClose()
    }
    return () => {
      // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
      window.onpopstate = null
    }
  }, [])

  let popupStyle = { maxHeight: 'var(--app-height)', minHeight: '50%', height: height }

  if (!isMobile()) {
    popupStyle = {
      left: `calc(50% - ${appWidth} / 2)`,
      width: appWidth,
      height: height,
    }
  }

  return (
    <>
      <Popup bodyStyle={popupStyle} position={position} visible={open} onClose={onClose} onMaskClick={onClose}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              backgroundColor: 'var(--theme-page-bgcolor)',
            }}>
            <Button size="small" color="primary" fill="none" onClick={onClose}>
              取消
            </Button>
            <span style={{ fontWeight: 'bold' }}>{title}</span>
            <Button size="small" color="primary" fill="solid" onClick={onClickSave} disabled={isLoading}>
              {saveContent || '保存'}
            </Button>
          </div>
          <div style={{ flex: 1, backgroundColor: 'var(--theme-page-bgcolor)', overflowY: 'auto' }}>{children}</div>
        </div>
      </Popup>
    </>
  )
}
